<template>
  <input
    ref="inputRef"
    type="text"
    class="chaicom-form-input"
    maxlength="10"
    @blur="blur"
    @keydown.prevent.enter="blur"
    @change="(e) => $emit('onChange', e.target.value)"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'
import { watch } from 'vue'

export default {
  name: 'CurrencyInput',
  emits: ['blur', 'onChange'],
  props: {
    value: Number,
    options: Object,
  },
  setup(props, { emit }) {
    const { inputRef, setOptions, setValue } = useCurrencyInput(props.options)

    watch(
      () => props.value,
      (value) => {
        setTimeout(() => {
          setValue(props.value)
        }, 100);
      },
      {
        immediate: true,
      }
    )

    watch(
      () => props.options,
      (options) => {
        setOptions(options)
      }
    )

    const blur = () => {
      inputRef.value.blur()
      emit('blur')
    }

    return { inputRef, blur }
  },
}
</script>
